import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Trademark Scribe - Professional Trademark & IP Services',
  description = 'Expert trademark registration, copyright protection, and business formation services. Protect your brand with our proven legal expertise and nationwide coverage.',
  keywords = 'trademark registration, copyright protection, patent services, business formation, LLC, C Corp, intellectual property',
  ogImage = 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85'
}) => {
  const fullTitle = title.includes('Trademark Scribe') ? title : `${title} | Trademark Scribe`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
